import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
import KrumosHeader from "@/components/KrumosHeader";
import { useUserStore } from "@/stores/UserStore";
import KrumosMenu from "@/components/KrumosMenu.vue";
import { computed, nextTick, ref, watch } from "vue";
import { useMessageStore } from "@/stores/MessageStore";
import { useRouter } from "vue-router";
import { useDisplay } from "vuetify";
import { useSettingsStore } from "@/stores/SettingsStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const userStore = useUserStore();
        const messageStore = useMessageStore();
        const drawer = ref(false);
        const router = useRouter();
        const display = useDisplay();
        const settingsStore = useSettingsStore();
        settingsStore.loadSettings();
        let alert = ref([]);
        function getSnackbarMargin(index) {
            return 70 + index * 60 + 'px';
        }
        const errors = computed(() => {
            return [...messageStore.errors];
        });
        const isPublicView = computed(() => {
            const allowAnonymous = router.currentRoute.value.meta.allowAnonymous;
            return allowAnonymous ? allowAnonymous : false;
        });
        watch(errors, (newValue, oldValue) => {
            if (newValue.length > oldValue.length) {
                nextTick(() => {
                    alert.value[0].$el.scrollIntoView({ behavior: "smooth", block: "center" });
                });
            }
        }, { deep: true });
        return (_ctx, _cache) => {
            const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_router_view = _resolveComponent("router-view");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_main = _resolveComponent("v-main");
            const _component_v_app = _resolveComponent("v-app");
            return (_unref(settingsStore).loaded)
                ? (_openBlock(), _createBlock(_component_v_app, {
                    key: 0,
                    id: "app"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(KrumosHeader), {
                            onToggleDrawer: _cache[0] || (_cache[0] = ($event) => (drawer.value = !drawer.value)),
                            class: _normalizeClass({
                                'px-50': (isPublicView.value && _unref(display).xlAndUp.value),
                                'px-25': (isPublicView.value && _unref(display).lg.value),
                            })
                        }, null, 8, ["class"]),
                        (!!_unref(userStore).user.token)
                            ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
                                key: 0,
                                theme: "dark",
                                modelValue: drawer.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((drawer).value = $event))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(KrumosMenu)
                                ]),
                                _: 1
                            }, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_v_main, null, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageStore).messages, (message, index) => {
                                    return (_openBlock(), _createBlock(_component_v_snackbar, {
                                        key: index,
                                        style: _normalizeStyle({ 'margin-top': getSnackbarMargin(index) }),
                                        color: "#4CAF50B0",
                                        "model-value": true,
                                        location: "top"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(message.message), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["style"]));
                                }), 128)),
                                _createVNode(_component_v_container, {
                                    class: _normalizeClass(["v-col-12 ma-0", {
                                            'px-50': (isPublicView.value && _unref(display).xlAndUp.value),
                                            'px-25': (isPublicView.value && _unref(display).lg.value),
                                            'pa-0': _unref(display).xs.value,
                                            'pa-2': !isPublicView.value,
                                        }])
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageStore).errors, (error, index) => {
                                            return (_openBlock(), _createBlock(_component_v_alert, {
                                                ref_for: true,
                                                ref_key: "alert",
                                                ref: alert,
                                                class: "mb-2 shake",
                                                key: index,
                                                "model-value": true,
                                                variant: "tonal",
                                                type: "error",
                                                border: "start",
                                                "data-cy": "alert"
                                            }, {
                                                close: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                        onClick: ($event) => (_unref(messageStore).removeError(index))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { icon: "mdi-close" })
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["onClick"])
                                                ]),
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(error) + " ", 1)
                                                ]),
                                                _: 2
                                            }, 1024));
                                        }), 128)),
                                        _createVNode(_component_router_view)
                                    ]),
                                    _: 1
                                }, 8, ["class"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
